// Backport from AngularJS (webroot/_ui/desktop/common/js/angular/controllers/cartPageController.js)
import logger from '../utils/rbata.logger';
import urlService from '../services/rbata.urlService';
import cartTracking from '../tracking/rbata.tracking.cart';
import consumerEvents from '../tracking/rbata.consumer-events';
import spinner from '../utils/rbata.spinner';
import cartCounter from './rbata.cart-counter';
import navigationState from '../checkout/rbata.navigationState';

const removeCartItem = {
    $body: undefined,
    init() {
        this.$body = $('body');
        this.bindEvents();
    },
    removeItemFromCart(entryNumber, reload = true) {
        let request = $.ajax({
            url:         `${urlService.getBaseUrl()}cart/removeCartItem`,
            method:      'POST',
            dataType:    'json',
            contentType: 'application/json',
            data:        JSON.stringify({
                entryNumber: entryNumber
            })
        });
        if (reload) {
            spinner.visibility(true);
        }
        request.done((response) => {
            if (response.success === true) {
                cartCounter.updateCounter(response.cartData.totalUnitCount);
                cartTracking.removeFromCart(response.trackingProductData, response.trackingProductData.quantity);
                consumerEvents.trackRemoveFromCartEvent(response.trackingProductData);

                if (response.cartData.totalUnitCount === 0) {
                    navigationState.resetStepState();
                }

                if (reload) {
                    setTimeout(() => {
                        window.location.reload();
                    }, 250);
                }
            } else {
                spinner.visibility(false);
            }
        });
        request.fail((jqXHR) => {
            logger.error(`${jqXHR.status} error in selectQuantity.updateQuantity`);
            window.location.reload();
        });

        return request;
    },
    bindEvents() {
        this.$body.on('click', '.js-remove-entry', (evt) => {
            evt.preventDefault();
            const entryNumber = evt.currentTarget.dataset.entryNumber;

            this.removeItemFromCart(entryNumber);
        });
    },
};

$(() => {
    if ($('#cart-page').length) {
        removeCartItem.init();
    }
});

export default removeCartItem;
